import Styles from './CalendarEventCard.module.scss'
import { VideoDuration } from 'components/VideoDuration/VideoDuration'
import { Play3 } from 'blaze-ui/icons'

export interface DurationProps {
  duration?: number
}

export const Duration = ({ duration }: DurationProps) => {
  if (!duration) return null

  return (
    <>
      <div className={Styles.playButtonOverlay}>
        <Play3 size={24} />
      </div>
      <VideoDuration
        duration={duration}
        iconSize={12}
        showIcon={false}
        containerClassName={Styles.videoDurationBottom}
        textClassName={Styles.videoDurationText}
      />
    </>
  )
}
